import { initContract } from "@ts-rest/core";
import {
  GetBlogRequest,
  GetBlogResponse,
  GetBlogsRequest,
  GetBlogsResponse,
} from "./types";
import { createPaginatedResponseSchema } from "contract/utils";

const c = initContract();

export const blogContract = c.router(
  {
    getBlogs: {
      method: "GET",
      path: "/all",
      responses: {
        200: createPaginatedResponseSchema(GetBlogsResponse),
      },
      query: GetBlogsRequest,
    },
    getBlog: {
      method: "GET",
      path: "/",
      responses: {
        200: GetBlogResponse,
      },
      query: GetBlogRequest,
    },
  },
  { pathPrefix: "/blog" }
);
